import { render } from "./AddonRelated.vue?vue&type=template&id=6977d0e1&scoped=true"
import script from "./AddonRelated.vue?vue&type=script&lang=js"
export * from "./AddonRelated.vue?vue&type=script&lang=js"

import "./AddonRelated.vue?vue&type=style&index=0&id=6977d0e1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6977d0e1"]])

export default __exports__